module.exports = __webpack_public_path__ + "img/notebook-dados.859d71ff.png";